import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-validate',
  templateUrl: './validate.component.html',
  styleUrls: ['./validate.component.scss']
})
export class ValidateComponent implements OnInit {
  userType: string;
  userLocation: string;
  constructor( private router: Router) {
    this.userType = AppStorageUtil.getItem('Usertype');
    this.userLocation = AppStorageUtil.getItem('manufacturingLocation');
    if (this.userType === 'Supplier') {
      if (this.userLocation === 'US' || this.userLocation === 'Canada') {
        this.router.navigate(['dashboard/supplier']);
      } else {
       this.router.navigate(['dashboard/supplier/ecommerce']);
      }
    } else if (this.userType === 'Buyer') {
      this.router.navigate(['dashboard/buyer/default']);
    } else if (this.userType === null) {
      AppStorageUtil.clear();
      this.router.navigate(['auth/login/simple']);
    }
   }

  ngOnInit() {

  }

}
